import React from 'react';
import styled from 'styled-components';
import CellItem from './CellItem';
import GroupItem from './GroupItem';
import RowItems from './RowItems';

function Item(props) {
	const {groupHeaderLabel, groupConfig, listData, isGrouped, index, idAttributeName} = props;

	const GroupHeaderItems = () => {
		return (
			<StyledHeaderBadgeSection className="header-badge-wrap">
				<GroupItem
					cellType={'GroupHeaderCell'}
					groupHeaderLabel={groupHeaderLabel}
					className={groupConfig.className}
					groupConfig={groupConfig}
					listData={listData}
					key={`${groupHeaderLabel ? groupHeaderLabel : ''}_GroupHeaderCell`}
				></GroupItem>
			</StyledHeaderBadgeSection>
		);
	};

	const getGroupRowKey = (cellType) => {
		return `${props.itemcomponentkey ? props.itemcomponentkey : ''}_${cellType}`;
	};

	const getRowItemComponentKey = (rowData, index) =>{
		let key = "";
		key = rowData[idAttributeName] ? rowData[idAttributeName] : '';
		if(!key){
			key = rowData.id;
		}
		key = `${key ? key : index}_RowCell`;
		return key;
	}

	const getRowItems = () => {
	return (<RowItems
				groupName = {groupHeaderLabel}
				cellType={'GroupCell'} 
				key = {getGroupRowKey('GroupCell')}
				groupConfig = {groupConfig} 
				listData = {listData}
				listRowItemClassName = {groupConfig.listRowItemClassName}
				getRowItemComponentKey = {getRowItemComponentKey}
				
			>
				
			</RowItems>)
	}


	return <>{isGrouped ? GroupHeaderItems() : getRowItems()}</>;
}

export default Item;

const StyledHeaderBadgeSection = styled.section`
	display: flex;
	background: ${(props) => props.theme.color[`grey235`]};
	font-size: 1.4rem;
	flex-direction: column;
`;

const StyledGroupRowItemSection = styled.section`
	width: 100%;
	display: flex;
	flex: 1;
	overflow: auto;
	.items-group-header {
		display: flex;
		flex: 1;
		overflow: auto;
		width: 100%;
	}
`;
